// extracted by mini-css-extract-plugin
export default {"green":"green___FkORL","layout":"layout___jeQUw","ctaText":"ctaText___PVV_K"};